export default function($) {
  $('#js-filters-toggle').on('click', function() {
    $('#js-filters').slideToggle('fast');
  });

  if ($(window).width() >= 1024) {
    $('.js-filter-checkbox').on('change', function() {
      $(this).closest('form').submit();
    });
  }
}
